module.exports = __webpack_public_path__ + "static/media/loader.dc685e44.svg";